import { GlowColor, SolanaTransactionInfo } from "@glow/shared";
import AppInteractionIcon from "../../icons/AppInteractionFilled.svg";
import BidIcon from "../../icons/activity/Bid.svg";
import BidSolidIcon from "../../icons/activity/BidSolid.svg";
import BonusIcon from "../../icons/activity/Bonus.svg";
import BonusSolidIcon from "../../icons/activity/BonusSolid.svg";
import BurnIcon from "../../icons/activity/Burn.svg";
import BurnSolidIcon from "../../icons/activity/BurnSolid.svg";
import BuyNFTIcon from "../../icons/activity/BuyNFT.svg";
import BuyNFTSolidIcon from "../../icons/activity/BuyNFTSolid.svg";
import CancelBidIcon from "../../icons/activity/CancelBid.svg";
import CancelBidSolidIcon from "../../icons/activity/CancelBidSolid.svg";
import DiamondIcon from "../../icons/Diamond.svg";
import DollarIcon from "../../icons/Dollar16.svg";
import FormFunctionIcon from "../../icons/Formfn.svg";
import FractalIcon from "../../icons/Fractal.svg";
import GenericTxIcon from "../../icons/activity/GenericTx.svg";
import GenericTxSolidIcon from "../../icons/activity/GenericTxSolid.svg";
import HyperspaceIcon from "../../icons/Hyperspace.svg";
import InfoIcon from "../../icons/Info16.svg";
import InfoSolidIcon from "../../icons/InfoFilled16.svg";
import InviteIcon from "../../icons/Invite16.svg";
import ListNFTIcon from "../../icons/activity/ListNFT.svg";
import ListNFTSolidIcon from "../../icons/activity/ListNFTSolid.svg";
import MagicEdenIcon from "../../icons/MagicEden.svg";
import MarketplaceDepositIcon from "../../icons/activity/MarketplaceDeposit.svg";
import MarketplaceDepositSolidIcon from "../../icons/activity/MarketplaceDepositSolid.svg";
import MarketplaceIcon from "../../icons/Marketplace16.svg";
import MarketplaceSolidIcon from "../../icons/MarketplaceFilled16.svg";
import MarketplaceWithdrawIcon from "../../icons/activity/MarketplaceWithdraw.svg";
import MarketplaceWithdrawSolidIcon from "../../icons/activity/MarketplaceWithdrawSolid.svg";
import MintIcon from "../../icons/activity/Mint.svg";
import MintSolidIcon from "../../icons/activity/MintSolid.svg";
import OpenSeaIcon from "../../icons/OpenSea.svg";
import ReceiveIcon from "../../icons/activity/Receive.svg";
import ReceiveSolidIcon from "../../icons/activity/ReceiveSolid.svg";
import RegisterIcon from "../../icons/activity/Register.svg";
import RegisterSolidIcon from "../../icons/activity/RegisterSolid.svg";
import SendIcon from "../../icons/activity/Send.svg";
import SendSolidIcon from "../../icons/activity/SendSolid.svg";
import SolanartIcon from "../../icons/Solanart.svg";
import StakeIcon from "../../icons/activity/Stake.svg";
import StakeSolidIcon from "../../icons/activity/StakeSolid.svg";
import StakeWithdrawIcon from "../../icons/activity/StakeWithdraw.svg";
import StakeWithdrawSolidIcon from "../../icons/activity/StakeWithdrawSolid.svg";
import SubaccountCleanedUpIcon from "../../icons/activity/SubaccountCleanedUp.svg";
import SubaccountCleanedUpSolidIcon from "../../icons/activity/SubaccountCleanedUpSolid.svg";
import SubaccountSetUpIcon from "../../icons/activity/SubaccountSetUp.svg";
import SubaccountSetUpSolidIcon from "../../icons/activity/SubaccountSetUpSolid.svg";
import SwapIcon from "../../icons/activity/Swap.svg";
import SwapSolidIcon from "../../icons/activity/SwapSolid.svg";
import TagIcon from "../../icons/Tag.svg";
import TagSolidIcon from "../../icons/TagFilled.svg";
import TickIcon from "../../icons/Tick16.svg";
import TickSolidIcon from "../../icons/TickFilled.svg";
import UnlistNFTIcon from "../../icons/activity/UnlistNFT.svg";
import UnlistNFTSolidIcon from "../../icons/activity/UnlistNFTSolid.svg";
import UnstakeIcon from "../../icons/activity/Unstake.svg";
import UnstakeSolidIcon from "../../icons/activity/UnstakeSolid.svg";
import UpdateIcon from "../../icons/activity/Updated.svg";
import UpdateSolidIcon from "../../icons/activity/UpdatedSolid.svg";
import WalletIcon from "../../icons/Wallet16.svg";
import WalletSolidIcon from "../../icons/WalletFilled16-2.svg";
import XIcon from "@lux/icons/feather/x.svg";
import YawwwIcon from "../../icons/Yawww.svg";

import React from "react";

export type IconConfig = {
  outline: React.ReactNode;
  solid: React.ReactNode;
  color: GlowColor;
};

export const LibraryIcons: Record<
  SolanaTransactionInfo.IconName,
  // We add `| null` here to ensure the types defend against null values. This helps with backwards
  // compatibility as the server adds new icons.
  IconConfig | null
> = {
  [SolanaTransactionInfo.IconName.Failed]: {
    outline: <XIcon />,
    solid: <XIcon />,
    color: GlowColor.Red,
  },

  [SolanaTransactionInfo.IconName.Tick]: {
    outline: <TickIcon />,
    solid: <TickSolidIcon />,
    color: GlowColor.Orange,
  },
  [SolanaTransactionInfo.IconName.AppInteraction]: {
    outline: <AppInteractionIcon />,
    solid: <AppInteractionIcon />,
    color: GlowColor.Gray,
  },
  [SolanaTransactionInfo.IconName.Bid]: {
    outline: <BidIcon />,
    solid: <BidSolidIcon />,
    color: GlowColor.Yellow,
  },
  [SolanaTransactionInfo.IconName.Burn]: {
    outline: <BurnIcon />,
    solid: <BurnSolidIcon />,
    color: GlowColor.Orange,
  },
  [SolanaTransactionInfo.IconName.BuyNft]: {
    outline: <BuyNFTIcon />,
    solid: <BuyNFTSolidIcon />,
    color: GlowColor.Purple,
  },
  [SolanaTransactionInfo.IconName.SoldNft]: {
    outline: <BuyNFTIcon />,
    solid: <BuyNFTSolidIcon />,
    color: GlowColor.Cranberry,
  },
  [SolanaTransactionInfo.IconName.CancelBid]: {
    outline: <CancelBidIcon />,
    solid: <CancelBidSolidIcon />,
    color: GlowColor.Gray,
  },
  [SolanaTransactionInfo.IconName.Diamond]: {
    outline: <DiamondIcon />,
    solid: <DiamondIcon />,
    color: GlowColor.Gray,
  },
  [SolanaTransactionInfo.IconName.Dollar]: {
    outline: <DollarIcon />,
    solid: <DollarIcon />,
    color: GlowColor.Gray,
  },
  [SolanaTransactionInfo.IconName.FormFunction]: {
    outline: <FormFunctionIcon />,
    solid: <FormFunctionIcon />,
    color: GlowColor.Gray,
  },
  [SolanaTransactionInfo.IconName.Fractal]: {
    outline: <FractalIcon />,
    solid: <FractalIcon />,
    color: GlowColor.Gray,
  },
  [SolanaTransactionInfo.IconName.Generic]: {
    outline: <GenericTxIcon />,
    solid: <GenericTxSolidIcon />,
    color: GlowColor.Gray,
  },
  [SolanaTransactionInfo.IconName.Hyperspace]: {
    outline: <HyperspaceIcon />,
    solid: <HyperspaceIcon />,
    color: GlowColor.Gray,
  },
  [SolanaTransactionInfo.IconName.Info]: {
    outline: <InfoIcon />,
    solid: <InfoSolidIcon />,
    color: GlowColor.Gray,
  },
  [SolanaTransactionInfo.IconName.Invite]: {
    outline: <InviteIcon />,
    solid: <InviteIcon />,
    color: GlowColor.Gray,
  },
  [SolanaTransactionInfo.IconName.ListNft]: {
    outline: <ListNFTIcon />,
    solid: <ListNFTSolidIcon />,
    color: GlowColor.Gray,
  },
  [SolanaTransactionInfo.IconName.Marketplace]: {
    outline: <MarketplaceIcon />,
    solid: <MarketplaceSolidIcon />,
    color: GlowColor.Gray,
  },
  [SolanaTransactionInfo.IconName.MagicEden]: {
    outline: <MagicEdenIcon />,
    solid: <MagicEdenIcon />,
    color: GlowColor.Gray,
  },
  [SolanaTransactionInfo.IconName.Mint]: {
    outline: <MintIcon />,
    solid: <MintSolidIcon />,
    color: GlowColor.Gray,
  },
  [SolanaTransactionInfo.IconName.OpenSea]: {
    outline: <OpenSeaIcon />,
    solid: <OpenSeaIcon />,
    color: GlowColor.Gray,
  },
  [SolanaTransactionInfo.IconName.Send]: {
    outline: <SendIcon />,
    solid: <SendSolidIcon />,
    color: GlowColor.Red,
  },
  [SolanaTransactionInfo.IconName.Receive]: {
    outline: <ReceiveIcon />,
    solid: <ReceiveSolidIcon />,
    color: GlowColor.Green,
  },
  [SolanaTransactionInfo.IconName.Swap]: {
    outline: <SwapIcon />,
    solid: <SwapSolidIcon />,
    color: GlowColor.Blue,
  },
  [SolanaTransactionInfo.IconName.Stake]: {
    outline: <StakeIcon />,
    solid: <StakeSolidIcon />,
    color: GlowColor.Orange,
  },
  [SolanaTransactionInfo.IconName.StakeWithdraw]: {
    outline: <StakeWithdrawIcon />,
    solid: <StakeWithdrawSolidIcon />,
    color: GlowColor.Purple,
  },
  [SolanaTransactionInfo.IconName.Solanart]: {
    outline: <SolanartIcon />,
    solid: <SolanartIcon />,
    color: GlowColor.Gray,
  },
  [SolanaTransactionInfo.IconName.SubaccountSetUp]: {
    outline: <SubaccountSetUpIcon />,
    solid: <SubaccountSetUpSolidIcon />,
    color: GlowColor.Gray,
  },
  [SolanaTransactionInfo.IconName.SubaccountCleanedUp]: {
    outline: <SubaccountCleanedUpIcon />,
    solid: <SubaccountCleanedUpSolidIcon />,
    color: GlowColor.Green,
  },
  [SolanaTransactionInfo.IconName.MarketplaceDeposit]: {
    outline: <MarketplaceDepositIcon />,
    solid: <MarketplaceDepositSolidIcon />,
    color: GlowColor.Yellow,
  },
  [SolanaTransactionInfo.IconName.MarketplaceWithdraw]: {
    outline: <MarketplaceWithdrawIcon />,
    solid: <MarketplaceWithdrawSolidIcon />,
    color: GlowColor.Yellow,
  },
  [SolanaTransactionInfo.IconName.Register]: {
    outline: <RegisterIcon />,
    solid: <RegisterSolidIcon />,
    color: GlowColor.Barney,
  },
  [SolanaTransactionInfo.IconName.Tag]: {
    outline: <TagIcon />,
    solid: <TagSolidIcon />,
    color: GlowColor.Gray,
  },
  [SolanaTransactionInfo.IconName.UnlistNft]: {
    outline: <UnlistNFTIcon />,
    solid: <UnlistNFTSolidIcon />,
    color: GlowColor.Gray,
  },
  [SolanaTransactionInfo.IconName.Unstake]: {
    outline: <UnstakeIcon />,
    solid: <UnstakeSolidIcon />,
    color: GlowColor.Barney,
  },
  [SolanaTransactionInfo.IconName.Updated]: {
    outline: <UpdateIcon />,
    solid: <UpdateSolidIcon />,
    color: GlowColor.Yellow,
  },
  [SolanaTransactionInfo.IconName.Referral]: {
    outline: <BonusIcon />,
    solid: <BonusSolidIcon />,
    color: GlowColor.Orange,
  },
  [SolanaTransactionInfo.IconName.Wallet]: {
    outline: <WalletIcon />,
    solid: <WalletSolidIcon />,
    color: GlowColor.Gray,
  },
  [SolanaTransactionInfo.IconName.Yawww]: {
    outline: <YawwwIcon />,
    solid: <YawwwIcon />,
    color: GlowColor.Gray,
  },
};

export function LibraryIcon({
  icon,
  variant,
  size,
}: {
  icon: SolanaTransactionInfo.IconName;
  size?: number | string;
  variant?: "outline" | "solid";
}) {
  const iconSize = size ?? "1rem";
  const iconVariant = variant ?? "outline";

  const appIcon = LibraryIcons[icon]?.[iconVariant];
  if (!appIcon) {
    return null;
  }

  return (
    <div className="flex" style={{ width: iconSize, height: iconSize }}>
      {appIcon}
    </div>
  );
}
